// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Common = require("../utils/Common.bs.js");
var Caml_option = require("rescript/lib/js/caml_option.js");
var Expln_React_Row = require("../../rescript-utils/main/react-mui-components/Expln_React_Row.bs.js");
var MM_react_common = require("../ui-utils/MM_react_common.bs.js");
var Expln_React_Column = require("../../rescript-utils/main/react-mui-components/Expln_React_Column.bs.js");
var Expln_React_common = require("../../rescript-utils/main/Expln_React_common.bs.js");
var Paper = require("@mui/material/Paper").default;
var Button = require("@mui/material/Button").default;
var TextField = require("@mui/material/TextField").default;

var checkMarkSymbol = "\u2713";

var crossSymbol = "\u2717";

function MM_cmp_test_regex(props) {
  var onCancel = props.onCancel;
  var onSave = props.onSave;
  var initRegex = props.initRegex;
  var match = React.useState(function () {
        return "";
      });
  var setText = match[1];
  var text = match[0];
  var match$1 = React.useState(function () {
        return initRegex;
      });
  var setRegex = match$1[1];
  var regex = match$1[0];
  var match$2 = React.useState(function () {
        
      });
  var setResult = match$2[1];
  var result = match$2[0];
  var actTextUpdated = function (str) {
    Curry._1(setText, (function (param) {
            return str;
          }));
    Curry._1(setResult, (function (param) {
            
          }));
  };
  var actRegexUpdated = function (str) {
    Curry._1(setRegex, (function (param) {
            return str;
          }));
    Curry._1(setResult, (function (param) {
            
          }));
  };
  var actTestRegex = function (param) {
    var msg = Common.strToRegex(regex);
    if (msg.TAG === /* Ok */0) {
      var re = msg._0;
      return Curry._1(setResult, (function (param) {
                    return {
                            TAG: /* Ok */0,
                            _0: re.test(text)
                          };
                  }));
    }
    var msg$1 = msg._0;
    Curry._1(setResult, (function (param) {
            return {
                    TAG: /* Error */1,
                    _0: msg$1
                  };
          }));
  };
  var rndText = function (param) {
    return React.createElement(TextField, {
                value: text,
                label: "Text to test regex on",
                size: "small",
                style: {
                  width: "800px"
                },
                multiline: true,
                maxRows: 10,
                onChange: (function (param) {
                    return Expln_React_common.evt2str(actTextUpdated, param);
                  }),
                onKeyDown: MM_react_common.kbrdHnd(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel, undefined),
                autoFocus: true
              });
  };
  var rndRegex = function (param) {
    var partial_arg = MM_react_common.kbrdClbkMake(MM_react_common.keyEsc, undefined, undefined, undefined, onCancel, undefined);
    var partial_arg$1 = MM_react_common.kbrdClbkMake(MM_react_common.keyEnter, undefined, undefined, undefined, actTestRegex, undefined);
    return React.createElement(Expln_React_Row.make, {
                children: Caml_option.some(null)
              }, React.createElement(TextField, {
                    value: regex,
                    label: "Regex",
                    size: "small",
                    style: {
                      width: "722px"
                    },
                    onChange: (function (param) {
                        return Expln_React_common.evt2str(actRegexUpdated, param);
                      }),
                    onKeyDown: (function (param) {
                        return MM_react_common.kbrdHnd2(partial_arg$1, partial_arg, param);
                      })
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        actTestRegex(undefined);
                      }),
                    variant: "contained",
                    disabled: regex.trim().length === 0,
                    color: "grey",
                    children: "Test"
                  }));
  };
  var rndResult = function (param) {
    if (result !== undefined) {
      if (result.TAG === /* Ok */0) {
        if (result._0) {
          return React.createElement("span", undefined, React.createElement("span", {
                          style: {
                            color: "green",
                            fontWeight: "bold"
                          }
                        }, checkMarkSymbol), " the regex matches the text.");
        } else {
          return React.createElement("span", undefined, React.createElement("span", {
                          style: {
                            color: "red",
                            fontWeight: "bold"
                          }
                        }, crossSymbol), " the regex doesn't match the text.");
        }
      } else {
        return React.createElement("span", undefined, React.createElement("span", {
                        style: {
                          color: "red"
                        }
                      }, "Error: "), result._0);
      }
    } else {
      return "Click the \"TEST\" button to test the regex.";
    }
  };
  var rndButtons = function (param) {
    return React.createElement(Expln_React_Row.make, {
                alignItems: "center",
                children: Caml_option.some(null)
              }, React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onSave, regex);
                      }),
                    variant: "contained",
                    children: "Save regex"
                  }), React.createElement(Button, {
                    onClick: (function (param) {
                        Curry._1(onCancel, undefined);
                      }),
                    children: "Cancel"
                  }));
  };
  return React.createElement(Paper, {
              style: {
                padding: "15px"
              },
              children: Caml_option.some(React.createElement(Expln_React_Column.make, {
                        spacing: 2,
                        children: Caml_option.some(null)
                      }, rndText(undefined), rndRegex(undefined), rndResult(undefined), rndButtons(undefined)))
            });
}

var make = MM_cmp_test_regex;

exports.checkMarkSymbol = checkMarkSymbol;
exports.crossSymbol = crossSymbol;
exports.make = make;
/* react Not a pure module */
